import { Component, Inject, Injectable } from '@angular/core';
import type { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { DialogComponent } from '@shared/dialogs/dialog.component';

@Injectable({
    providedIn: 'root',
})
@Component({
    template: `
        <app-dialog-header>
            <app-dialog-title>
                {{ options.title }}
            </app-dialog-title>
        </app-dialog-header>

        <mat-dialog-content>
            {{ options.content }}
        </mat-dialog-content>

        <mat-dialog-actions>
            <button cll-filled-button
                    colour="primary"
                    (click)="okay()">
                {{ options.okay || 'Okay' }}
            </button>
        </mat-dialog-actions>
    `,
    styleUrls: ['./alert-dialog-component.service.scss'],
})
export class AlertDialogComponent extends DialogComponent {
    public options: DialogData;

    constructor(
        public dialogRef: MatDialogRef<AlertDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) {
        super();

        this.dialogRef = dialogRef;
        this.options = data;
    }

    okay() {
        this.dialogRef.close();
    }

    public static show(dialog: MatDialog, data: DialogData): MatDialogRef<AlertDialogComponent, void> {
        return dialog.open<AlertDialogComponent, DialogData, void>(AlertDialogComponent, {
            data,
            minWidth: '320px',
            maxWidth: '420px'
        });
    }
}

export interface DialogData {
    title: string;
    content?: string;
    okay?: string;
}
